import { render, staticRenderFns } from "./dialogLive.vue?vue&type=template&id=712b6aa0&scoped=true&"
import script from "./dialogLive.vue?vue&type=script&lang=js&"
export * from "./dialogLive.vue?vue&type=script&lang=js&"
import style0 from "./dialogLive.vue?vue&type=style&index=0&id=712b6aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712b6aa0",
  null
  
)

export default component.exports